module.exports = __webpack_public_path__ + "img/finance.ff80b805.png";